/**
 * Formats a mobile number by adding separators.
 *
 * @param {string} mobileNo - The mobile number to be formatted.
 * @param {string} separator - The separator to be added between the different parts of the mobile number. Defaults to a space.
 * @return {string} The formatted mobile number.
 */
export const formatMobileNumber = (mobileNo: string, separator = " ") => {
  // Remove any non-digit characters from the input string
  const cleanedNumber = mobileNo?.replace(/\D/g, "");

  if (cleanedNumber?.length !== 10) {
    return mobileNo;
  }

  const head = cleanedNumber.slice(0, 3);
  const middle = cleanedNumber.slice(3, 6);
  const tail = cleanedNumber.slice(6);

  const formattedNumber = `${head}${separator}${middle}${separator}${tail}`;

  return formattedNumber;
};

export const formatMobileNumberStartWithTwoDigitAreaCode = (
  mobileNo: string,
  separator = " "
) => {
  // Remove any non-digit characters from the input string
  const cleanedNumber = mobileNo?.replace(/\D/g, "");

  if (cleanedNumber?.length !== 10) {
    return mobileNo;
  }

  const head = cleanedNumber.slice(0, 2);
  const middle = cleanedNumber.slice(2, 6);
  const tail = cleanedNumber.slice(6);

  const formattedNumber = `${head}${separator}${middle}${separator}${tail}`;

  return formattedNumber;
};

export const formatMobileNumberToInternal = (
  mobileNo: string,
  separator = " "
) => {
  // Remove any non-digit characters from the input string
  let cleanedNumber = mobileNo?.replace(/\D/g, "");

  if (cleanedNumber?.startsWith("66")) {
    cleanedNumber = cleanedNumber.replace("66", "0");
  }

  if (cleanedNumber?.length !== 10) {
    return mobileNo;
  }

  const head = cleanedNumber.slice(0, 2);
  const middle = cleanedNumber.slice(2, 6);
  const tail = cleanedNumber.slice(6);

  const formattedNumber = `${head}${separator}${middle}${separator}${tail}`;

  return formattedNumber;
};

export const formatNumberToThaiCurrency = (number: number) => {
  const hasDecimal = number % 1 !== 0;
  return number.toLocaleString("th-TH", {
    style: "currency",
    currency: "THB",
    maximumFractionDigits: hasDecimal ? 2 : 0,
    minimumFractionDigits: hasDecimal ? 2 : 0,
  });
};

export function snakeToCamelCase(str: string): string {
  return str.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace("-", "").replace("_", "")
  );
}
